import Swal from 'sweetalert2';

export const hideModal = <T extends object>(result?: { value?: T }) => {
  return Swal.close({ isConfirmed: true, isDismissed: false, ...result });
};
